import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Lagerliste } from '../../data/lagerliste';

import { TabComponent } from '@softline/ui-core/tab-group';
import { TabGroupComponent } from '@softline/ui-core/tab-group';
import { TabTitleDirective } from '@softline/ui-core/tab-group';
@Component({
  selector: 'soft-rohstoffbereitstellung-lager-card',
  templateUrl: './lager-card.component.html',
  styleUrls: ['./lager-card.component.html'],
  imports: [CommonModule,
    TabComponent,
    TabGroupComponent],
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush })
export default class LagerCardComponent {
  lagerliste = input.required<Lagerliste>();

  readonly tabIndex = signal(0);

  readonly selectedLager = computed(() => {
    const lagerliste = this.lagerliste();
    const index = this.tabIndex();
    return lagerliste.lagerstaende[index] ?? lagerliste[0];
  });
}
